/**
 * GENERATED — do not edit. Source: tutorial-anchors.yaml
 * Regenerate with: pnpm --filter @managing-up/schema generate
 */
/** Bumped whenever an anchor is added, removed, or renamed. */
export const TUTORIAL_ANCHORS_VERSION = '1.0.0';
/**
 * The closed set of interface regions a package's `tutorial` steps may point
 * at. Packages may not extend it; the application must register every entry.
 */
export const TUTORIAL_ANCHORS = {
    'sidebar.channels': {
        label: 'The channel list',
        description: 'The rooms the player can read, in the workspace sidebar. Below the layout breakpoint this lives in a drawer, so a step pointing here is skipped while the drawer is shut.',
    },
    'sidebar.puppets': {
        label: 'The puppet panel',
        description: 'Whose voice the player can borrow, and the attention bandwidth it costs. Rendered only once a package declares puppets, so a mission without them never presents a step pointing here.',
    },
    'header.status': {
        label: 'Where you stand',
        description: 'The standing readouts in the channel header — Corporate Cred and the HR strike ladder. The place to watch what a send costs.',
    },
    'header.phase': {
        label: 'The clock',
        description: 'The day, the phase, and the phases remaining, in the channel header. The budget the whole mission is spent against.',
    },
    'feed.messages': {
        label: 'The conversation',
        description: 'The message feed for the open channel. The thread being read, as distinct from the controls used to answer it.',
    },
    'feed.highlight': {
        label: 'A harvestable phrase',
        description: 'A highlighted span inside a message — the only way new phrases enter the tray. Points at the first such span on screen, and is skipped when the open channel has none.',
    },
    'rail.hint': {
        label: 'The hint ladder',
        description: 'The hint control on the feedback rail, between the conversation and the composer.',
    },
    'composer.slots': {
        label: 'The slots',
        description: 'The composer\'s slot tray: one segment per active slot, and the phrases chosen into them. Where a message is built, since the player never types.',
    },
    'composer.identity': {
        label: 'Whose voice',
        description: 'The composer\'s identity control — speaking as yourself, or through a puppet the player has acquired.',
    },
    'composer.target': {
        label: 'Who it goes to',
        description: 'The composer\'s addressee control. The same assembly lands differently on different readers, so this is a move rather than a formality.',
    },
    'composer.send': {
        label: 'Send',
        description: 'The composer\'s send control. Blocked only while a required slot is empty, no addressee is chosen, or the composer is locked.',
    },
    'dock.divider': {
        label: 'The message-space divider',
        description: 'The grab handle on the composer dock\'s top edge, which moves the split between the conversation and the controls.',
    },
    'flight.indicator': {
        label: 'Proposals in flight',
        description: 'Sent proposals still travelling, with the ticks they have left. A proposal can still be changed while its ticks last.',
    },
};
/** Every anchor id, in declaration order. */
export const TUTORIAL_ANCHOR_IDS = ['sidebar.channels', 'sidebar.puppets', 'header.status', 'header.phase', 'feed.messages', 'feed.highlight', 'rail.hint', 'composer.slots', 'composer.identity', 'composer.target', 'composer.send', 'dock.divider', 'flight.indicator'];
//# sourceMappingURL=tutorial-anchors.js.map